/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import { injectIntl } from 'react-intl';
import {
  DropdownButton,
  MenuItem,
} from 'react-bootstrap';
import IntlMsg from 'lorautils/intl/IntlMsg';
import { kTimeRanges } from '../../constants';

const propTypes = {
  value: React.PropTypes.string.isRequired,
  onSelect: React.PropTypes.func.isRequired,
  intl: React.PropTypes.any.isRequired,
};

class TimeRangeButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
    this.intlMsg = new IntlMsg(props.intl, 'applicationdetail.parseview.dptrend.timeranges');
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    if (value !== this.props.value) {
      this.setState({ value });
    }
  }

  render() {
    const { onSelect } = this.props;
    const { value } = this.state;
    return (
      <DropdownButton
        id="time-range"
        bsStyle="aisz-time-range"
        title={this.intlMsg.msg(value)}
        onSelect={onSelect}
        pullRight
      >
        {kTimeRanges.map(tr => (
          <MenuItem key={tr} eventKey={tr}>
            {this.intlMsg.msg(tr)}
          </MenuItem>
        ))}
      </DropdownButton>
    );
  }
}

TimeRangeButton.propTypes = propTypes;

export default injectIntl(TimeRangeButton);




// WEBPACK FOOTER //
// ./src/containers/Application/coms/ApplicationDetail/coms/DataPointsView/coms/DataPointTrend/coms/TimeRangeButton/index.jsx